import { render } from "./OrderImport.vue?vue&type=template&id=17c63dcb"
import script from "./OrderImport.vue?vue&type=script&lang=js"
export * from "./OrderImport.vue?vue&type=script&lang=js"

import "./OrderImport.vue?vue&type=style&index=0&id=17c63dcb&lang=css"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QSpinner,QBtn,QFile,QTable});
